<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-08 17:38:23
 * @LastEditors: HG
 * @LastEditTime: 2019-08-13 15:21:25
 -->
<template>
  <div class="date-picker">
    <div class="week">
      <van-grid :column-num="7" :border="false">
        <van-grid-item v-for="item in week" :key="item" :text="item" />
      </van-grid>
    </div>

    <div class="date-box">
      <van-swipe :show-indicators="false">
        <van-swipe-item v-for="(item, index) in dateData" :key="index">
          <van-grid :column-num="7">
            <van-grid-item
              v-for="date in item"
              :key="date.date"
              :class="{
                disabled: date.disabled,
                today: date.date === today,
                selected: date.selected
              }"
              :clickable="true"
              @click="dateClick(date)"
            >
              <div class="text">
                {{ date.day }}
                <p class="desc">{{ date.desc }}</p>
              </div>
            </van-grid-item>
          </van-grid>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Grid, GridItem } from "vant";
import chunk from "lodash/chunk";
import { formatDate, getWeek, countDate, getTimestamp } from "@/utils/common";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "DateCardPicker",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      today: formatDate(),
      week: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      dateData: [],
      startDate: "",
      endDate: ""
    };
  },
  model: {
    prop: "value",
    event: "update"
  },
  watch: {
    value() {
      this.copyData();
    }
  },
  created() {
    this.dateData = this.getData();
    this.copyData();
  },
  methods: {
    copyData() {
      const copyValue = cloneDeep(this.value);
      if (copyValue && copyValue.length) {
        this.startDate = copyValue[0];
        this.endDate = copyValue[1];
      } else {
        this.startDate = "";
        this.endDate = "";
      }
      this.dateData = this.getData();
    },
    getData() {
      //获取当前
      const date = this.today;
      const week = getWeek(date);
      const w = week > 0 ? week : 7;
      const startDate = countDate(date, -w);
      let data = [];
      for (let i = 0; i < 42; i++) {
        const d = countDate(startDate, i);
        let disabled = i < w;
        const day = d.split("-")[2];
        const month = d.split("-")[1];

        let desc = "";
        let selected = false;
        if (day === "01") {
          let m = month;
          if (month.indexOf("0") > -1) {
            m = month.split("")[1];
          }
          desc = m + "月";
        }
        if (this.startDate && d === this.startDate) {
          selected = true;
          if (this.endDate && this.endDate !== this.startDate) {
            desc = "开始";
          }
        } else if (this.endDate && d === this.endDate) {
          selected = true;
          desc = "结束";
        } else if (this.startDate && this.endDate) {
          const startDateStamp = getTimestamp(this.startDate);
          const endDateStamp = getTimestamp(this.endDate);
          const dStamp = getTimestamp(d);
          if (dStamp > startDateStamp && dStamp < endDateStamp) {
            selected = true;
          }
        }
        if (this.disabled) {
          disabled = true;
          if (d === this.today) {
            selected = true;
            this.startDate = this.today;
            this.endDate = this.today;
          }
        }
        data.push({
          date: d,
          day: day,
          selected: selected,
          disabled: disabled,
          desc: desc
        });
      }
      const dateData = chunk(data, 21);
      return dateData;
    },

    dateClick(data) {
      if (data.disabled) return;
      const date = data.date;
      if (!this.startDate) {
        this.startDate = date;
        this.endDate = "";
      } else if (!this.endDate) {
        if (getTimestamp(this.startDate) > getTimestamp(date)) {
          this.endDate = this.startDate;
          this.startDate = date;
        } else {
          this.endDate = date;
        }
      } else {
        this.startDate = date;
        this.endDate = "";
      }
      this.dateData = this.getData();
      this.$emit("update", [this.startDate, this.endDate]);
    }
  }
};
</script>

<style lang="less"></style>
